<template> 
  <div>
    <div  class="btn-group"  v-if="row.status==1">
      <!--span class="icon icon icon-circle-clock mt-1 mr-1"> </span--> 
      <div  class="pendiente">
        <img class="" src="@/assets/images/icons/circle-clock2.svg">
        <span  class="span-check">Pendiente</span>
        </div> 
    </div>
    <div  class="btn-group"  v-if="row.status==2">
      <!--span class="icon icon-lock mt-1 mr-1"> </span> Cerrado</span-->
<div  class="cerrado">
          
           <img class="" src="@/assets/images/icons/circle-check2.svg">
           <span  class="span-check">Cerrado</span>
           </div>
      
    </div>
    <div  class="btn-group"  v-if="row.status==3">
      <!-- span class="icon icon-cancel-circle mt-1 mr-1"> </span> Rechazado</span-->
      <div  class="cerrado">
          
           <img class="" src="@/assets/images/icons/circle-check2.svg">
           <span  class="span-check">Cerrado</span>
           </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "EditFieldDelete",
  data() {
    return {
      selected: false
    }
  },
  props: ['row','field'],
  computed: {
    ...mapState("modTipshiftReport", ["tipshift","selectAll"]),
      ...mapGetters([
      'modTipshiftReport',
      ["getAllSelected"]
    ]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
      "actEliminarRegistroNovedad"
    ]),
    
    eliminarRegistroNovedad(id){
      this.actEliminarRegistroNovedad(id);
    },

  },
};
</script>

<style lang="scss" scoped>
  .icon-circle-check {
      color: #779b49;
  }

  .icon-lock {
    color: #e48d3d;
  }

  .icon-cancel-circle {
    color: #e4433d;
  }
</style>